export const BOOKKEEPING_SOFTWARE = "BOOKKEEPING_SOFTWARE";
export const BOOKKEEPING = "BOOKKEEPING";
export const BOOKKEEPING_V2 = "BOOKKEEPING_V2";
export const PLATFORM = "PLATFORM";
export const REGISTERED_AGENT = "REGISTERED_AGENT";
export const MAILROOM = "MAILROOM";
export const BOOKKEEPING_SOFTWARE_MANAGE = "BOOKKEEPING_SOFTWARE_MANAGE";
export const BOOKKEEPING_MANAGE = "BOOKKEEPING_MANAGE";
export const BOOKKEEPING_V2_MANAGE = "BOOKKEEPING_V2_MANAGE";
export const REGISTERED_AGENT_MANAGE = "REGISTERED_AGENT_MANAGE";
export const MAILROOM_MANAGE = "MAILROOM_MANAGE";
export const _MANAGE = "_MANAGE";
export const GROUP_BOOKS_CONSOLIDATION = "GROUP_BOOKS_CONSOLIDATION";
export const GROUP_BOOKS_CONSOLIDATION_MANAGE =
  "GROUP_BOOKS_CONSOLIDATION_MANAGE";
export const BOOKS_PLUS_PLAN = "BOOKS_PLUS_PLAN";
export const BOOKS_PLUS_PLAN_MANAGE = "BOOKS_PLUS_PLAN_MANAGE";
export const SALES_TAX_FILING = "SALES_TAX_FILING";
export const SALES_TAX_FILING_MANAGE = "SALES_TAX_FILING_MANAGE";
export const FRACTIONAL_PAYROLL_ADMINISTRATOR =
  "FRACTIONAL_PAYROLL_ADMINISTRATOR";
export const FRACTIONAL_PAYROLL_ADMINISTRATOR_MANAGE =
  "FRACTIONAL_PAYROLL_ADMINISTRATOR_MANAGE";
export const BOOKKEEPING_MONTHLY_PLUS = "Bookkeeping Monthly +";
export const BOOKKEEPING_MONTHLY = "Bookkeeping Monthly";
